import React from 'react';

import { BadgeStyled } from './badge-styled';

type BadgeProps = {
  content?: string;
};

const Badge = ({ content = '' }: BadgeProps): JSX.Element => {
  return <BadgeStyled>{content}</BadgeStyled>;
};

export default Badge;
